import { request } from '@umijs/max';
import {
  ModifyDefaultCommunityParamsType,
  UnBindCommunityParamsType,
} from '@/pages/Community/interface';

/**
 * @desc 解绑小区
 * @param data
 */
export const queryUnBindCommunity = async (data: UnBindCommunityParamsType) => {
  return request('/api/property/api/senke/Wxchat/relieveBinding/community', {
    method: 'POST',
    data,
  });
};
/**
 * @desc 设置默认小区
 * @param data
 */
export const querySetDefaultCommunity = async (
  data: ModifyDefaultCommunityParamsType,
) => {
  return request('/api/property/api/senke/Wxchat/modify/account', {
    method: 'POST',
    data,
  });
};
